import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5422b622"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "history-wrapper"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  class: "history-title"
}, "История заказов", -1));
const _hoisted_3 = {
  key: 0,
  class: "history__content"
};
const _hoisted_4 = {
  key: 0,
  class: "history__block"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "history-subtitle"
}, "Готовятся", -1));
const _hoisted_6 = {
  class: "history__box"
};
const _hoisted_7 = {
  key: 1,
  class: "history__block"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "history-subtitle"
}, "Доставленные", -1));
const _hoisted_9 = {
  class: "history__box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_HistoryOrders = _resolveComponent("HistoryOrders");
  const _component_el_collapse = _resolveComponent("el-collapse");
  const _component_el_skeleton = _resolveComponent("el-skeleton");
  const _component_EmptyBlock = _resolveComponent("EmptyBlock");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, $data.ordersProcess.length > 0 || $data.ordersComplete.length > 0 || $data.loadingOrders ? (_openBlock(), _createElementBlock("div", _hoisted_3, [$data.ordersProcess.length > 0 || $data.loadingOrders ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_hoisted_5, !$data.loadingOrders ? (_openBlock(), _createBlock(_component_el_collapse, {
    key: 0,
    modelValue: $data.activeItem1,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.activeItem1 = $event),
    accordion: ""
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.ordersProcess, (item, id) => {
      return _openBlock(), _createElementBlock("div", {
        class: "history__item",
        key: id
      }, [_createVNode(_component_HistoryOrders, {
        order: item,
        id: id,
        activeItem: $data.activeItem1
      }, null, 8, ["order", "id", "activeItem"])]);
    }), 128))])]),
    _: 1
  }, 8, ["modelValue"])) : (_openBlock(), _createBlock(_component_el_skeleton, {
    key: 1,
    animated: ""
  }))])) : _createCommentVNode("", true), $data.ordersComplete.length > 0 || $data.loadingOrders ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_hoisted_8, !$data.loadingOrders ? (_openBlock(), _createBlock(_component_el_collapse, {
    key: 0,
    modelValue: $data.activeItem2,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.activeItem2 = $event),
    accordion: ""
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.ordersComplete, (item, id) => {
      return _openBlock(), _createElementBlock("div", {
        class: "history__item",
        key: id
      }, [_createVNode(_component_HistoryOrders, {
        order: item,
        id: id,
        activeItem: $data.activeItem2
      }, null, 8, ["order", "id", "activeItem"])]);
    }), 128))])]),
    _: 1
  }, 8, ["modelValue"])) : (_openBlock(), _createBlock(_component_el_skeleton, {
    key: 1,
    animated: ""
  }))])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $data.ordersProcess.length === 0 && $data.ordersComplete.length === 0 && !$data.loadingOrders ? (_openBlock(), _createBlock(_component_EmptyBlock, {
    key: 1,
    class: "history-empty",
    imgUrl: require('@/img/icon/empty.svg'),
    title: "У вас нет заказов",
    text: "Переходите в интересующую вас категорию и сделайте свой первый заказ"
  }, null, 8, ["imgUrl"])) : _createCommentVNode("", true)]);
}